import React from 'react';

interface IProps {
  text: string;
  icon: React.ReactNode;
  isReverse?: boolean;
  fill: boolean;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const MenuButton = ({
  text,
  icon,
  isReverse,
  fill,
  onClick,
  disabled,
  className = ''
}: IProps) => {
  const content = isReverse ? (
    <>
      <span>{text}</span>
      {icon}
    </>
  ) : (
    <>
      {icon}
      <span>{text}</span>
    </>
  );

  const baseStyles = `
    flex items-center justify-center gap-[6px]
    py-[10px] px-[20px] min-w-fit w-[228px] h-[42px] max-w-full
    font-body text-[16px] font-medium leading-[140%]
    rounded-[32px] transition-all duration-200
    whitespace-nowrap 
  `;

  const fillStyles = fill
    ? 'bg-blue-500 border border-blue-600 text-base-black hover:shadow-[0_0_0_4px_rgba(93,225,255,0.2)]'
    : 'border-2 border-gray-500 text-base-black hover:shadow-[0_0_0_4px_rgba(93,225,255,0.2)]';

  const disabledStyles = disabled
    ? 'opacity-40 cursor-not-allowed hover:shadow-none'
    : '';

  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className={`${baseStyles} ${fillStyles} ${disabledStyles} ${className}`}
    >
      {content}
    </button>
  );
};
